import { Box, Grid, Stack } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/** MyMine Version2.0 SpecializedPartsServiceLv2SubLv2画面新規追加
* SpecializedPartsServiceLv2SubLv2 Page Content
*/
export const SpecializedPartsServiceLv2SubLv2 = () => {
  // 画面幅が400px以上899px以下かどうかを判定
  const isMediumScreen = useMediaQuery('(min-width: 400px) and (max-width: 899px)');

  
  const mediumScreenImageSize = {
    width: '345px',
    height: '210px',
  };

  const ImageLinkPanel = (props) => {
    const { index, headerText, linkText, url, imgPath, detailText } = props;

    return (
      <Box key={index}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          background: constants.CorporateColor.Heparts,
          paddingLeft: '5px'
        }}>
          <MyMLabel fontSize='25px'>{headerText}</MyMLabel>
        </Box>
        <Grid container sx={{ paddingLeft: 1 }} rowSpacing={2}>
          <Grid item xs={12} lg={9}>
            <MyMLabel sx={{ marginTop: '20px' }}>{detailText}</MyMLabel>
            <MyMButton
              sx={{ marginTop: '10px' }}
              onClick={() => window.open(url, '_blank')}
            >
              {linkText}
            </MyMButton>
          </Grid>
          <Grid item xs={12} lg={3} className='d-flex justify-content-center align-items-center'>
            <MyMImage
              screenId={screenId}
              filePath={imgPath}
              alt='HEPartsImage'
              height={isMediumScreen ? mediumScreenImageSize.height : '130px'} 
              width={isMediumScreen ? mediumScreenImageSize.width : '180px'}  
              display='block'
            />
          </Grid>
        </Grid>
      </Box>
    );
  }

  const ImagePanel = (props) => {
    const { index, captionText, imgPath } = props;

    return (
      <Grid item xs={12} md={6} lg={4} key={index} sx={{ marginTop: '30px' }}>
        <Box sx={{ marginBottom: '15px' }}>
          <Box sx={{
            height: isMediumScreen ? mediumScreenImageSize.height : '130px', 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <MyMImage
              screenId={screenId}
              filePath={imgPath}
              alt='HEPartsImage'
              height='100%'
              width='100%'
              display='block'
              style={{ objectFit: 'contain' }} 
            />
          </Box>
          <MyMLabel sx={{ marginTop: '5px', textAlign: 'center' }}>{captionText}</MyMLabel>
        </Box>
      </Grid>
    );
  }

  const screenId = 'MyM308';
  const scrollmRef = useRef(null);
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isInitLoading, setIsInitLoading] = useState(true);
  const isPc = useMediaQuery(mediaQuery.pc);

  useEffect(() => {
    const endLoading = () => setIsInitLoading(false);

    apiRequest.requestJson('api/specialized-parts-service/lv2-2', 'GET', endLoading, endLoading);
  }, []);

  if (isInitLoading)
    return <MyMProgress />

  const SectionLabel = (props) => (
    <MyMVariantLabel variant='h4' className='fs-3 fw-bolder'>{props.children}</MyMVariantLabel>
  );

  return (
    <Box className='py-1'>
      <Box>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblHEParts}</MyMVariantLabel>
      </Box>
      {isPc ? (
        <Grid container>
          <Grid item xs={3} />
          <Grid item xs={6}>
            <Box sx={{ marginTop: 1 }} ref={scrollmRef}>
              <SectionLabel>{controlSettings.LabelList.lblProductsAndSolutions}</SectionLabel>
              <Stack className='ps-3' sx={{ mt: 2, marginBottom: '20px' }} spacing={3}>
                {[...Array(6)].map((_, i) => {
                  const headerText = controlSettings.LabelList['lblProductsAndSolutionsHeader' + (1 + i)];
                  const detailText = controlSettings.LabelList['lblProductsAndSolutionsDetail' + (1 + i)];
                  const linkText = controlSettings.LabelList['lnkProductsAndSolutionsSeeMoreDetails' + (1 + i)];
                  const url = controlSettings.UrlList['urlProductsAndSolutionsSeeMoreDetails' + (1 + i)];
                  const imgPath = controlSettings.ImageList['imgProductsAndSolutions' + (1 + i)];

                  if (!headerText || !detailText || !linkText || !url || !imgPath) {
                    return null;
                  }

                  return (
                    <ImageLinkPanel
                      key={i}
                      headerText={headerText}
                      detailText={detailText}
                      linkText={linkText}
                      url={url}
                      imgPath={imgPath}
                    />
                  );
                })}
              </Stack>
            </Box>
            <Box sx={{ marginTop: 7 }}>
              <SectionLabel>{controlSettings.LabelList.lblHotTopic}</SectionLabel>
              <Grid className='ps-3' container>
                {[...Array(6)].map((_, i) => {
                  const caption = controlSettings.LabelList['lblHotTopicCaption' + (i + 1)];
                  const imgPath = controlSettings.ImageList['imgHotTopic' + (i + 1)];

                  if (!caption || !imgPath) {
                    return null;
                  }

                  return (
                    <ImagePanel
                      key={i}
                      index={i}
                      captionText={caption}
                      imgPath={imgPath}
                    />
                  );
                })}
              </Grid>
            </Box>
            <Box sx={{ marginTop: 7 }}>
              <SectionLabel>{controlSettings.LabelList.lblOurWorkplace}</SectionLabel>
              <Grid className='ps-3' container>
                {[...Array(6)].map((_, i) => {
                  const caption = controlSettings.LabelList['lblOurWorkplaceCaption' + (i + 1)];
                  const imgPath = controlSettings.ImageList['imgOurWorkplace' + (i + 1)];

                  if (!caption || !imgPath) {
                    return null;
                  }

                  return (
                    <ImagePanel
                      key={i}
                      index={i}
                      captionText={caption}
                      imgPath={imgPath}
                    />
                  );
                })}
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={3} />
        </Grid>
      ) : (
        <Box sx={{ width: '100%' }}>
          <Box sx={{ marginTop: 1 }} ref={scrollmRef}>
            <SectionLabel>{controlSettings.LabelList.lblProductsAndSolutions}</SectionLabel>
            <Stack sx={{ mt: 2, marginBottom: '20px' }} spacing={3}>
              {[...Array(6)].map((_, i) => {
                const headerText = controlSettings.LabelList['lblProductsAndSolutionsHeader' + (1 + i)];
                const detailText = controlSettings.LabelList['lblProductsAndSolutionsDetail' + (1 + i)];
                const linkText = controlSettings.LabelList['lnkProductsAndSolutionsSeeMoreDetails' + (1 + i)];
                const url = controlSettings.UrlList['urlProductsAndSolutionsSeeMoreDetails' + (1 + i)];
                const imgPath = controlSettings.ImageList['imgProductsAndSolutions' + (1 + i)];

                if (!headerText || !detailText || !linkText || !url || !imgPath) {
                  return null;
                }

                return (
                  <ImageLinkPanel
                    key={i}
                    headerText={headerText}
                    detailText={detailText}
                    linkText={linkText}
                    url={url}
                    imgPath={imgPath}
                  />
                );
              })}
            </Stack>
          </Box>
         
          <Box sx={{ marginTop: 7 }}>
            <SectionLabel>{controlSettings.LabelList.lblHotTopic}</SectionLabel>
            <Grid container>
              {[...Array(6)].map((_, i) => {
                const caption = controlSettings.LabelList['lblHotTopicCaption' + (i + 1)];
                const imgPath = controlSettings.ImageList['imgHotTopic' + (i + 1)];

                if (!caption || !imgPath) {
                  return null;
                }

                return (
                  <ImagePanel
                    key={i}
                    index={i}
                    captionText={caption}
                    imgPath={imgPath}
                  />
                );
              })}
            </Grid>
          </Box>
          <Box sx={{ marginTop: 7 }}>
            <SectionLabel>{controlSettings.LabelList.lblOurWorkplace}</SectionLabel>
            <Grid container>
              {[...Array(6)].map((_, i) => {
                const caption = controlSettings.LabelList['lblOurWorkplaceCaption' + (i + 1)];
                const imgPath = controlSettings.ImageList['imgOurWorkplace' + (i + 1)];

                if (!caption || !imgPath) {
                  return null;
                }

                return (
                  <ImagePanel
                    key={i}
                    index={i}
                    captionText={caption}
                    imgPath={imgPath}
                  />
                );
              })}
            </Grid>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default SpecializedPartsServiceLv2SubLv2;
